<template>
    <div class="win">
        <div class="header">
            <div class="navItem">
                <i class="iconfont el-icon-setting"></i>
                <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px':''}">设备舱维护</div>
            </div>
        </div>
        <div class="content" v-loading="loading" element-loading-text="Loading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(42, 43, 44, 0.6)">
            <el-form @submit.native.prevent class="table_header tableSearchForm" :inline="true" size="small" label-width="120px" label-position="left" style="margin-top: 0px">
                <div class="btn btn_active" style="margin-right: 10px" @click="handleAdd"><span>{{ $t('ems.add') }}</span></div>
            </el-form>
            <el-table
                    :data="list"
                    style="width: 100%"
                    v-loading="listLoading"
                    border
                    size="small"
                    :height="720"
                    class="BMSTable"
            >
                <el-table-column  label="编号" prop="containerNo"></el-table-column>
                <el-table-column  label="名称" prop="containerName"></el-table-column>
                <el-table-column  label="英文名称"  prop="containerNameEn" ></el-table-column>
                <el-table-column  label="拓展字段"  prop="exdInfo"></el-table-column>
                <el-table-column  label="所属父柜"  prop="pid">
                    <template slot-scope="scope">
                        <span>{{showName(scope.row.pid)}}</span>
                    </template>
                </el-table-column>
                <el-table-column  :label="$t('ems.operate')" align="center" width="240">
                    <template slot-scope="scope">
                        <el-button @click.native.prevent="handleEdit(scope.row)" type="text" size="small" icon="el-icon-edit-outline">编辑</el-button>
                        <el-button @click.native.prevent="handleDelete(scope.row.id)" type="text" size="small" icon="el-icon-edit-outline">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="addVisible">
            <el-dialog :title="addForm.id == undefined ? '新增' : '编辑'" :visible.sync="addVisible" append-to-body width="600px"
                       top="200px" :close-on-click-modal="false" custom-class="dialog-custom-class">
                <el-form @submit.native.prevent class="table_header tableSearchForm" style="width: 100%; margin-left: 60px" size="small" label-width="100px" label-position="left" :model="addForm" :rules="rules" ref="ruleForm">
                    <el-form-item label="编号" v-if="addForm.id !== undefined"><el-input v-model="addForm.containerNo"  style="width: 300px" disabled></el-input></el-form-item>
                    <el-form-item label="名称" prop="containerName"><el-input v-model="addForm.containerName"  style="width: 300px"></el-input></el-form-item>
                    <el-form-item label="英文名称" prop="containerNameEn"><el-input v-model="addForm.containerNameEn" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px" ></el-input></el-form-item>
                    <el-form-item label="扩展字段">
                        <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="addForm.exdInfo"  style="width: 300px"></el-input>
                    </el-form-item>
                    <el-form-item label="所属父柜" prop="pid">
                        <el-select v-model="addForm.pid" placeholder="请选择" style="width: 300px" popper-class="selectDown">
                            <el-option label="无" value="0"></el-option>
                            <el-option v-for="item in options" :key="item.id" :label="item.containerName" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="addVisible = false">{{ $t('ems.strategy.cancel') }}</el-button>
                    <el-button size="small" type="primary" @click="subminAdd">{{ $t('ems.strategy.confirm') }}</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import { getContainerList, containerUpdate, removeContainer }from "@/api/spms";
    import i18n from "@/lang";
    export default {
        name: "mainSys",
        data(){
            return{
                opacity: 0,
                loading: false,
                form: {
                },
                listLoading: false,
                list: [],
                addVisible: false,
                addForm: {
                    account: '',
                    realName: '',
                    phone: '',
                    roleId: ''
                },
                roleList: [],
                rules: {
                    containerName: { required: true, message: "请输入内容", trigger: 'blur' },
                    containerNameEn: { required: true, message: "请输入内容", trigger: 'blur' },
                    pid: {  required: true, message: "请选择", trigger: 'change' },
                },

            }
        },
        computed: {
            ...mapGetters(["language"]),
            options(){
                return this.list.filter(i => this.addForm && this.addForm.id !== i.id )
            },


        },
        filters: {
            nullFormat(val){
                if(val === null || val === undefined){
                    return "--"
                }else {
                    return val
                }
            },

            showTypeF(val){
                if(val == 0){
                    return "不可见";
                }else if(val == 1){
                    return  '可见灰色显示';
                }else if(val === 2){
                    return  '可见正常显示';
                }else {
                    return  "--"
                }
            }
        },
        mounted(){
            setTimeout(() => {
                this.opacity = 1;
            },200);
            this.loadData();
        },
        methods: {
            showName(pid){
                if(pid == 0){
                    return "无"
                }else{
                    return (this.list.find(i => i.id == pid) || {}).containerName
                }
            },
            search(){
                this.loadData();
            },
            loadData(){
                this.listLoading = true;
                getContainerList().then(res => {
                    this.listLoading = false;
                    this.list = res.data.data.records;
                }).catch(err => {
                    this.listLoading = false;
                    console.log(err)
                });
            },
            handleSizeChange(val) {
                this.page = 1;
                this.size = val;
                this.loadData();
            },
            handleCurrentChange(val) {
                this.page = val;
                this.loadData();
            },

            handleEdit(row){
                this.addForm = {...row};
                this.addForm.pid =  this.addForm.pid + '';
                this.addVisible= true;
            },
            handleAdd(){
                this.addForm = { pid: '0' };
                this.addVisible= true;
            },
            subminAdd(){
                this.$refs["ruleForm"].validate((valid) => {
                    if (valid) {
                        this.addVisible = false;
                        const params = {...this.addForm};
                        params.bmsId = 1;
                        containerUpdate(params).then(() => {
                            this.$message.success("操作成功！");
                            this.loadData();
                        }).catch(err => {
                            console.log(err);
                            this.$message.error(i18n.t("ems.addFailedTip") + err)
                        });
                    } else {
                        return false;
                    }
                });
            },
            handleDelete(id){
                this.$confirm(i18n.t("ems.alarm.sureyouwanttodothis"), {
                    confirmButtonText: i18n.t("ems.strategy.confirm"),
                    cancelButtonText:  i18n.t("ems.strategy.cancel"),
                    type: "warning"
                }).then(() => {
                    removeContainer(id).then(() =>  {
                        this.$message.success(i18n.t("ems.strategy.DeletedSuccessfully"));
                        this.loadData();
                    }).catch(err => {
                        this.$message.error(err)
                    });
                }).then(() => {
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "../../styles/site";
    .win{
        width: 100%;
        height: 100%;
        .header{
            height: 52px;
            background-color: var(--nav_inner);
            position: relative;
            .navItem{
                height: 100%;
                color: $font_bright_blue_title;
                display: flex;
                align-items: center;
                transition: all 0.3s linear;
                i{
                    font-size: 22px;
                    margin: 3px 20px 0;
                }
                .title{
                    letter-spacing: 3px;
                    font-size: 22px;
                }
                .desc{
                    margin-left: 24px;
                    font-size: 16px;
                    color: $_128_128_128;
                }
            }
            .navRight{
                position: absolute;
                height: 100%;
                right: 0;
                top: 0;
                display: flex;
                align-items: center;
                .creatTime{
                    font-size: 18px;
                    color: $_191_191_191;
                    margin-right: 40px;
                    span{
                        padding-left: 20px;
                        color: $font_bright_blue_title
                    }
                }
                .btn{
                    height: 30px;
                    width: 85px;
                    border: $font_bright_blue_title solid 2px;
                    margin-right: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 16px;
                    color: $font_bright_blue_title;
                    cursor: pointer;
                    -webkit-tap-highlight-color:rgba(0,0,0,0);
                    i{
                        margin-right: 5px;
                        font-size: 18px;
                    }
                }
            }
        }
        .content{
            padding: 20px;
            overflow: hidden;

            .table_header {
                margin-top: 20px;
                height: 30px;
                margin-bottom: 20px;
            }
            .page{
                margin-top: 20px;
                height: 30px;
            }
            .strategy_main {
                height: 780px;
            }
        }
    }
</style>